// 日志管理
import { Request } from '@/http/request'

// 管理员登陆
export function logsList (parameter: any) {
  return Request.axiosInstance.post('/system/log-op/list', parameter)
}

export default { logsList }